import * as React from "react";
import { CalendarEvent } from "../CalendarEventUtils/CalendarEvent";
import { SetState } from "source/app/services/UI/State/SetState";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { ECalendarName } from "motw_core/Calendar/ECalendarName";
import { ISyncNotificationState } from "source/app/presentation/Header/Center/Sync/ISyncNotificationState";

export function HandleCurrentEvent(currentIncompleteEvents: CalendarEvent[]) {
    const currentIncompleteEvent = currentIncompleteEvents[0];

    const isFreeTimeEvent = currentIncompleteEvent.BelongsToCalendar(
        ECalendarName.Free
    );

    const color = isFreeTimeEvent ? `orange` : `inherit`;
    const shouldReduceOpacity =
        isFreeTimeEvent || currentIncompleteEvent.eventData.name === `?`;

    const headerElementToDisplay = (
        <span style={{ opacity: shouldReduceOpacity ? 0.2 : 0.7, color }}>
            {currentIncompleteEvent.eventData.name}
        </span>
    );

    SetState<ISyncNotificationState>(ESharedFunction.SyncNotification_state, {
        syncNotificationElement: headerElementToDisplay,
    });
}
